import React from 'react';

export default function FireTrainingFLHASubmitted() {
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h2>Thank you for your submission</h2>
      <p>Your Training FLHA has been submitted.</p>
    </div>
  );
}
